import styled from "styled-components";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/section/footer/Footer";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import MeasurementSection from "./components/MeasurementSection";

const Wrapper = styled.div``;

function MeasurementPage() {
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      <MeasurementSection />
      <Footer />
    </Wrapper>
  );
}

export default MeasurementPage;
